const AllCategories = {};

export default AllCategories